export const DEFAULT_TTL_MS = 8 * 60 * 1000 // 8 minutes
